import { InView } from 'react-intersection-observer'
import CloseButton from 'src/components/ClubComponents/CloseButton'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import type { StandardObject } from 'src/utils/amplitude/types/amplitudeObjects'

import type { ActionAppsProps, ButtonsAppsProps } from './PopUpAppsflyer'

type PopUpredirectToAppProps = {
  modalOpenApp: boolean
  isAppRefused: boolean
  standardObject: StandardObject | null
  handleSendEvent: (action: ActionAppsProps, button: ButtonsAppsProps) => void
  handleCloseApp: (button: ButtonsAppsProps) => void
  handleClickYes: (button: ButtonsAppsProps) => void
  handleClickNo: () => void
}

const PopUpredirectToApp = ({
  isAppRefused,
  modalOpenApp,
  standardObject,
  handleSendEvent,
  handleCloseApp,
  handleClickNo,
  handleClickYes,
}: PopUpredirectToAppProps) => {
  return (
    <InView
      className={`modals-appsflyer__modal open-app ${
        modalOpenApp || isAppRefused ? 'hidden' : 'flex'
      }`}
      as="div"
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          dispatchAmplitudeEvent({
            eventName: 'Modal Viewed',
            eventData: {
              ...standardObject,
              'modal nome':
                'Gostaria de ser redirecionado para o app para uma melhor experiência?',
            },
          })
        }
      }}
    >
      <button
        className="modals-appsflyer__modal--closeBtn"
        aria-label="close modal"
        onClick={() => {
          handleSendEvent('X', 'open-app')
          handleCloseApp('open-app')
          dispatchAmplitudeEvent({
            eventName: 'Click Button Modal',
            eventData: {
              ...standardObject,
              'modal nome':
                'Gostaria de ser redirecionado para o app para uma melhor experiência?',
              'modal botao nome': 'Fechar',
            },
          })
        }}
      >
        <CloseButton size={20} thickness={2} color="#0082C3" left="97%" />
      </button>
      <h2 className="modals-appsflyer__modal--title">
        Gostaria de ser redirecionado para o app para uma melhor experiência?
      </h2>
      <div className="modals-appsflyer__modal--btns">
        <button
          className="modals-appsflyer__modal--btn button-yes"
          onClick={() => {
            handleSendEvent('Sim', 'open-app')
            handleClickYes('open-app')
            dispatchAmplitudeEvent({
              eventName: 'Click Button Modal',
              eventData: {
                ...standardObject,
                'modal nome':
                  'Gostaria de ser redirecionado para o app para uma melhor experiência?',
                'modal botao nome': 'Sim',
              },
            })
          }}
        >
          Sim
        </button>
        <button
          className="modals-appsflyer__modal--btn button-no"
          onClick={() => {
            handleSendEvent('Não', 'open-app')
            handleClickNo()
            dispatchAmplitudeEvent({
              eventName: 'Click Button Modal',
              eventData: {
                ...standardObject,
                'modal nome':
                  'Gostaria de ser redirecionado para o app para uma melhor experiência?',
                'modal botao nome': 'Não',
              },
            })
          }}
        >
          Não
        </button>
      </div>
    </InView>
  )
}

export default PopUpredirectToApp
